<template>
  <div>
    <div class="module-list">
      <div class="action-bar-wrapper">
        <el-col :span="24" class="action-bar">
          <el-button type="primary" size="medium" @click="setModule({id:''})">添加</el-button>
        </el-col>
      </div>
      <el-table :data="tableData" v-loading="listLoading">
        <el-table-column align="center" prop="id" label="序号"/>
        <el-table-column align="center" prop="module_name" label="模块名称"/>
        <el-table-column align="center" prop="module_type_name" label="类型"/>
        <el-table-column align="center" prop="sort" label="排序"/>
        <el-table-column align="center" prop="status_name" label="状态"/>
        <el-table-column align="center" prop="created_at" label="创建时间"/>
        <el-table-column align="center" fixed="right" label="操作" >
          <template v-slot="scope">
            <el-button type="text" size="small" @click="setModule(scope.row)">编辑</el-button>
            <el-button style="color:#f56c6c;" @click="delServiceProviderModule(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div>
      <el-dialog title="新增/编辑" :visible.sync="dialogVisible" width="70%" :before-close="handleClose">
        <div>
          <el-form  :model="formData" :rules="rules" ref="ruleForm" label-width="120px" label-position="left">
            <div v-if="formData.module_name!=='单位简介'&&formData.module_name!=='业务范围'">
              <el-form-item label="模块名称" prop="module_name" >
                <el-input v-model="formData.module_name" placeholder="请输入模块名称" style="width:500px"/>
              </el-form-item>
              <el-form-item label="模块类型"  prop="module_type">
                <el-radio v-model="formData.module_type" label="content">富文本</el-radio>
                <el-radio v-model="formData.module_type" label="official_account_article">公众号文章</el-radio>
              </el-form-item>
              <el-form-item label="状态">
                <el-radio-group v-model="formData.status">
                  <el-radio :label="1">上架</el-radio>
                  <el-radio :label="0">下架</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <el-form-item label="排序">
              <el-input palceholder="数字越小，排序越前" type="number" v-model="formData.sort" style="width:500px"/>
            </el-form-item>
            <div v-if="formData.module_name!=='单位简介'&&formData.module_name!=='业务范围'">
              <el-form-item label="详情内容"  prop="detail"  v-if="formData.module_type==='content'">
                <vue-ueditor-wrap v-model="formData.detail" :config="myConfig"></vue-ueditor-wrap>
              </el-form-item>
              <div v-else>
                <el-form-item label="封面图"  prop="img_id">
                  <el-upload
                    class="avatar-uploader"
                    name="photo"
                    :action="UPLOAD_IMG"
                    :show-file-list="false"
                    :on-success="addUploadSuccess"
                  >
                    <img v-if="formData.img_url" :src="formData.img_url" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item label="文章标题" prop="title">
                  <el-input v-model="formData.title" placeholder="请输入文章标题" style="width:500px"/>
                </el-form-item>
                <el-form-item label="文章描述" prop="desc">
                  <el-input v-model="formData.desc" placeholder="请输入文章描述" style="width:500px"/>
                </el-form-item>
                <el-form-item label="文章链接" prop="link_url">
                  <el-input v-model="formData.link_url" placeholder="请输入文章链接" style="width:500px"/>
                </el-form-item>
              </div>
            </div>

          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="submitForm" :loading="submitLoading">保  存</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {BASE_URL} from "../../api";
import {UPLOAD_IMG} from "../../api/index.js";
export default {
  data(){
    return{
      UPLOAD_IMG,
      id:'',
      tableData:[],
      page:1,
      listLoading:false,
      dialogVisible:false,
      submitLoading:false,
      formData:{
        id:'',
        unit_id:'',
        module_name:'',
        module_type:'content',
        title:'',
        desc:'',
        link_url:'',
        img_id:'',
        detail:'',
        sort:'',
        imgUrl:'',
        status:1,
        img_url:''
      },
      rules:{
        module_name: [
          { required: true, message: '请输入模块名称', trigger: ['blur','change'] }
        ],
        title: [
          { required: true, message: '请输入文章标题', trigger: ['blur','change'] }
        ],
        desc: [
          { required: true, message: '请输入文章描述', trigger: ['blur','change'] }
        ],
        link_url: [
          { required: true, message: '请输入链接', trigger: ['blur','change'] }
        ],
        img_id: [
          { required: true, message: '请上传封面图', trigger: ['blur','change'] }
        ],
        detail: [
          { required: true, message: '请输入详情内容', trigger: ['blur','change'] }
        ],

      },
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 500,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: 'http://35.201.165.105:8000/controller.php',
        // https://shop.rzkeji.com/ueditor-php/controller.php
        serverUrl: BASE_URL + '/ueditor-php/controller.php',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        // //UEDITOR_HOME_URL: '/static/UEditor/'
        //UEDITOR_HOME_URL: '/peoples_association_backstage/dist//static/UEditor/'
        toolbars: [
          [
            'undo', 'redo', '|',
            'bold', 'italic', 'underline', 'strikethrough',
            'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor',
            'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
            'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
            'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
            'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
            'simpleupload', 'insertimage', 'insertvideo', 'music',
            'horizontal', 'date', 'time',
            'inserttable'
          ]
        ]
      }
    }
  },
  mounted() {
    if(this.$route.query.id){
      this.id = this.$route.query.id
      this.getServiceProviderModuleList()
    }
  },
  methods:{
    aaa(e){
      console.log(e)
    },
    setModule(row){
      this.dialogVisible=true
      this.formData.unit_id = this.id
      if(row.id){
        Object.assign(this.formData,row)
      }
    },
    // 编辑服务商模块
    async setServiceProviderModule(){
      this.submitLoading=true
      const {data:{level,message}} =await this.$api.setServiceProviderModule(this.formData)
      if(level=='success'){
         await this.getServiceProviderModuleList()
        this.handleClose()
      }
      this.$message({
        message: message,
        type: level
      })
      this.submitLoading=false
    },
    // 获取服务商模块列表
    async getServiceProviderModuleList(){
      this.listLoading=true
      let params={
        unit_id:this.id,
        limit:10,
        page:this.page
      }
      const {data:{level,data}} = await this.$api.getServiceProviderModuleList(params)
      if(level=='success'){
         this.tableData=data
      }
      this.listLoading=false
    },
    // 关闭弹窗
    handleClose(){
      this.dialogVisible = false
      this.$refs.ruleForm.resetFields();
      this.formData.module_name=''
      this.formData.id=''
      this.formData.module_type='content'
      this.formData.title=''
      this.formData.desc=''
      this.formData.link_url=''
      this.formData.img_id=''
      this.formData.detail=''
      this.formData.sort=''
      this.formData.status=1
      this.formData.img_url=''
    },
    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
           this.setServiceProviderModule()
        } else {
          return false;
        }
      });
    },
    //新增上传图片成功回调
    addUploadSuccess(res, file) {
      if(res.data){
        this.formData.img_url = res.data.img_url;
        this.formData.img_id = res.data.id;
      }
    },
    async delServiceProviderModule(id){
      this.$confirm('是否删除该模块?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const {data:{level,message}} =await this.$api.delServiceProviderModule({id})
        if(level=='success'){
         await this.getServiceProviderModuleList()
        }
        this.$message({
          message: message,
          type: level
        })
      }).catch(() => {

      });
    }
  }
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/vipCompany/vipCompany_module.vue